// AUTO-GENERATED by scripts/gen-name-index.ts — do not edit by hand.
export interface TranslationCountryName { slug: string; nameTh: string; nameEn: string }
export const TRANSLATION_COUNTRY_NAMES: TranslationCountryName[] = [
  {
    "slug": "australia",
    "nameTh": "ออสเตรเลีย",
    "nameEn": "Australia"
  },
  {
    "slug": "new-zealand",
    "nameTh": "นิวซีแลนด์",
    "nameEn": "New Zealand"
  },
  {
    "slug": "usa",
    "nameTh": "สหรัฐอเมริกา",
    "nameEn": "United States"
  },
  {
    "slug": "united-kingdom",
    "nameTh": "สหราชอาณาจักร",
    "nameEn": "United Kingdom"
  },
  {
    "slug": "germany",
    "nameTh": "เยอรมนี",
    "nameEn": "Germany"
  },
  {
    "slug": "france",
    "nameTh": "ฝรั่งเศส",
    "nameEn": "France"
  },
  {
    "slug": "spain",
    "nameTh": "สเปน",
    "nameEn": "Spain"
  },
  {
    "slug": "italy",
    "nameTh": "อิตาลี",
    "nameEn": "Italy"
  },
  {
    "slug": "netherlands",
    "nameTh": "เนเธอร์แลนด์",
    "nameEn": "Netherlands"
  },
  {
    "slug": "sweden",
    "nameTh": "สวีเดน",
    "nameEn": "Sweden"
  },
  {
    "slug": "japan",
    "nameTh": "ญี่ปุ่น",
    "nameEn": "Japan"
  },
  {
    "slug": "china",
    "nameTh": "จีน",
    "nameEn": "China"
  },
  {
    "slug": "south-korea",
    "nameTh": "เกาหลีใต้",
    "nameEn": "South Korea"
  },
  {
    "slug": "uae",
    "nameTh": "สหรัฐอาหรับเอมิเรตส์",
    "nameEn": "United Arab Emirates"
  },
  {
    "slug": "canada",
    "nameTh": "แคนาดา",
    "nameEn": "Canada"
  },
  {
    "slug": "saudi-arabia",
    "nameTh": "ซาอุดีอาระเบีย",
    "nameEn": "Saudi Arabia"
  },
  {
    "slug": "switzerland",
    "nameTh": "สวิตเซอร์แลนด์",
    "nameEn": "Switzerland"
  },
  {
    "slug": "denmark",
    "nameTh": "เดนมาร์ก",
    "nameEn": "Denmark"
  }
];
